module.exports = __webpack_public_path__ + "img/位图备份_8.4465389a.png";